import React from 'react';
import {formatPhoneNumber} from "../../utils/utils";

const TopBar = ({partner}) => {
    return (
        <div className="top-bar py-2">
            <div className="container-fluid justify-content-center">
                <div className="container-fluid container-xxl">
                    <div className="row align-items-center">
                        <div className="col-lg-4 d-lg-flex">
                            <div className="top-bar-item">
                                <i className="bi bi-telephone me-2"></i>
                                <span>So erreichen Sie uns: </span>
                                <a title={`So erreichen Sie uns ${partner.phone}`}
                                   href={`tel:${formatPhoneNumber(partner?.phone)}`}>{partner.phone}</a>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-12 text-center">
                            <div></div>
                        </div>

                        <div className="col-lg-4 d-none d-lg-block">
                            <div className="d-flex justify-content-end">
                                <div className="top-bar-item dropdown me-3">
                                    <a className="dropdown-item d-flex align-items-center"
                                       href="/newsletter-anmeldung" title="Newsletter Anmeldung">
                                        <i className="bi bi-envelope me-2"></i>
                                        <span>Newsletteranmeldung</span>
                                    </a>
                                </div>
                                <div className="top-bar-item dropdown  me-3">
                                    <a className="dropdown-item d-flex align-items-center"
                                       href="/katalog-gratis-bestellen" title="Katalog oder Prospekt gratis-bestellen">
                                        <i className="bi bi-newspaper me-2"></i>
                                        <span>Prospekt bestellen</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopBar;